(function($) {
    'use strict';

    //fixed header
    $(window).on('scroll', function() {
        /*if( $( '.header-content .photo' ).length ) {

            var scrollfromtop = 460;
            var paddingtop = '130px';

            if( $( window ).width() < 480 ) {
                var scrollfromtop = 600;
                var paddingtop = '270px';
            } else if ( $( window ).width() <= 768 && $( window ).width() >= 481 ) {
                var scrollfromtop = 560;
                var paddingtop = '300px';
            }

            //mijn profiel pagina
            if ($(window).scrollTop() >= scrollfromtop) { //@todo calculate this value
                $('.header-content').addClass('fixed-header');
                $('.coach-profile').css('padding-top',paddingtop);
            }
            else {
                $('.header-content').removeClass('fixed-header');
                $('.coach-profile').css('padding-top','50px');
            }
        }*/

        //mijn coaches pagina
        if ($(window).scrollTop() >= 70) { //@todo calculate this value
            $('.filter-bar-1').addClass('fixed-header');
            $('.filter-bar-3').css('margin-top','55px');
        }
        else {
            $('.filter-bar-1').removeClass('fixed-header');
            $('.filter-bar-3').css('margin-top','0px');
        }
    });

    // show a button on mobile after scrolling past the header
    if ($('.mobile-sticky-cta-button').length) {
        $(window).on('scroll', function() {
            var offsetTop = ($('.landing-header').height() + $('.landing-header').offset().top) - 70;
            
            if( $( window ).width() < 480 && $(window).scrollTop() >= offsetTop ) {
                $('.mobile-sticky-cta-button').addClass('show');
            } else {
                $('.mobile-sticky-cta-button').removeClass('show');
            }
        });
    }
})(jQuery);